import { createAction } from 'redux-starter-kit';
import { get, post } from '../../../../utility/via-fetch';
import { requestStart, requestFailed, requestSucceded } from '../../../domain/requests/RequestActions';
import { addMessage } from '../../application/messageUiActions';
import {putLocation, putLocations, putLocationsForSelect} from '../../../domain/locations/locationActions';

/**
 * An action that signifies a location is being currently edited.
 */
export const editLocation = createAction('EDIT_LOCATION');

/**
 * An action that signifies no location is being edited.
 */
export const cancelEditLocation = createAction('CANCEL_EDIT_LOCATION');

/**
 * An action that signifies a request to load locations has been made.
 */
export const fetchLocationPageData = createAction('FETCH_LOCATIONS_PAGE_DATA');
export const fetchLocationsForSelect = createAction('FETCH_LOCATIONS_FOR_SELECT');

/**
 * An action for loading all the data for the locations page.
 * @example dispatch(requestLocationPageData())
 */
export function requestLocationPageData() {
    return async (dispatch) => {
        const requestId = dispatch(requestStart(fetchLocationPageData.toString()));
        dispatch(fetchLocationPageData(requestId));

        try {
            const locations = await get('/api/locations/with-logo/');

            // Normalise data. Store the data in the domain, and the ids in the request response.
            dispatch(putLocations(locations));
            dispatch(requestSucceded(requestId));
        } catch (error) {
            dispatch(requestFailed(requestId, error));
        }
    };
}

/* for locations select */
export function requestLocationForSelect() {
    return async (dispatch) => {
        const requestId = dispatch(requestStart(fetchLocationsForSelect().toString()));
        dispatch(fetchLocationsForSelect(requestId));

        try {
            const locations = await get('/api/locations');

            // Normalise data. Store the data in the domain, and the ids in the request response.
            dispatch(putLocationsForSelect(locations));
            dispatch(requestSucceded(requestId));
        } catch (error) {
            dispatch(requestFailed(requestId, error));
        }
    };
}


/**
 * An action that signifies that a fetch to add a location has been
 * made in the locations configuration screen. This should pass through the request id.
 * @example dispatch(fetchAddLocation(requestId))
 */
export const fetchAddLocation = createAction('FETCH_CREATE_LOCATION');

/**
 * An action for creating a location on the server.
 * @param {object} location A location to be created.
 * @example dispatch(requestAddLocation(location));
 */
export function requestAddLocation(location) {
    return async (dispatch) => {
        const requestId = dispatch(requestStart(fetchAddLocation.toString()));
        dispatch(fetchAddLocation(requestId));
        try {
            location.locationCode = await post('/api/locations/with-logo', {}, location); // eslint-disable-line no-param-reassign
            dispatch(putLocation(location));
            dispatch(cancelEditLocation());
            dispatch(requestSucceded(requestId, location.locationCode));
            dispatch(addMessage('success', 'itemSaved', { item: location.locationDescription }));
        } catch (error) {
            dispatch(requestFailed(requestId, error));
        }
    };
}

/**
 * An action that signifies that a fetch to update a location
 * has been made in the locations configuration screen.
 * This should pass through the request id.
 * @example dispatch(fetchUpdateLocation(requestId));
 */
export const fetchUpdateLocation = createAction('FETCH_UPDATE_LOCATION');

export function requestUpdateLocation(location) {
    return async (dispatch) => {
        const requestId = dispatch(requestStart());
        dispatch(fetchUpdateLocation(requestId));
        try {
            await post(`/api/locations/with-logo/${location.locationCode}`, {}, location);
            dispatch(putLocation(location));
            dispatch(cancelEditLocation());
            dispatch(requestSucceded(requestId, location.locationCode));
            dispatch(addMessage('success', 'itemUpdated', { item: location.locationDescription }));
        } catch (error) {
            dispatch(requestFailed(requestId, error));
        }
    };
}

/**
 * Publish (active) actions.
 */
export const addPublishLocation = createAction('ADD_PENDING_PUBLISH_LOCATION');
export const removePublishLocation = createAction('REMOVE_PENDING_PUBLISH_LOCATION');

export function requestPublishLocation(location) {
    const toggledLocation = { ...location, active: !location.active };

    return async (dispatch) => {
        const requestId = dispatch(requestStart(addPublishLocation.toString()));
        dispatch(addPublishLocation(toggledLocation.locationCode));
        try {
            await post(`/api/locations/with-logo/${location.locationCode}`, {}, toggledLocation);
            dispatch(putLocation(toggledLocation));
            dispatch(addMessage('success', 'itemStateUpdated', { item: location.locationDescription }));
            dispatch(requestSucceded(requestId));
        } catch (error) {
            dispatch(requestFailed(requestId, error));
        }
        dispatch(removePublishLocation(toggledLocation.locationCode));
    };
}
